<template>
	<div class="field-container">
		<div class="field-container__wrapper">
			<Checkbox
				v-model="showFields"
				:labelText="title"
				:checkboxValue="title"
				@change="selectedOption" 
			/>
		</div>
		<div
			:class="{
				'field-container__visible': showFields,
				'field-container__hidden': !showFields
			}"
		>
			<InputPassword
				labelText="Applicant"
				:name="'inputApplicantApplicant'"
				:autocomplete="'new-password'"
				class="field-container__input"
				@change="appPin"
				@validate="onValidate"
				:validators="PINValidators"
				ref="refBureaus" 
			/>
			<InputPassword
				labelText="Co-Applicant"
				:name="'inputApplicantCo-Applicant'"
				:autocomplete="'new-password'"
				class="field-container__input"
				@change="coAppPin"
				@validate="onValidate"
				:validators="PINValidators"
				ref="refBureaus" 
			/>
		</div>
	</div>
</template>

<script>
import InputPassword from '@/components/forms/input/input-password.vue';
import Checkbox from '@/components/forms/selection-control/checkbox/checkbox.vue';
import pageMixin from '@/mixins/page-mixin';
import viewMixin from '@/mixins/view-mixin';
import { NumericValidator } from '@/validators';
import LengthValidator from '@/validators/length-validator';

export default {
	name: 'toggle-fields-form',
	mixins: [pageMixin, viewMixin],
	components: {
		InputPassword,
		Checkbox
	},
	data() {
		return {
			showFields: false,
			isFormValid: false,
			vState: [], 
			inputs: {
				name: '',
				checked: false,
				appPIN: '',
				coAppPIN: ''
			}
		};
	},
	props: {
		title: {
			type: String,
			required: true
		}
	},
	computed: {
		PINValidators() { 
 			return [
				new NumericValidator({
					validateOn: 'blur',
					message: 'Entry must be numeric'
				}),
				new LengthValidator({  
					minLength: 5,
					maxLength: 10,
					message: 'PINs must be 5-10 numbers',
					allowEmpty: true
				})
			];
		}
	}, 
	methods: {
		selectedOption({ value, checked }) {
			this.inputs.name = value;
			this.inputs.checked = checked;

			this.$emit('change', {
				values: this.inputs
			});
		},
		appPin(pin) {
			this.inputs.appPIN = pin;
			this.$emit('change', {
				values: this.inputs
			});
		},
		coAppPin(pin) {
			this.inputs.coAppPIN = pin;
			this.$emit('change', {
				values: this.inputs
			});
		},
		frVState(validation) {
			let newVState = this.vState.filter(
				s => s?.componentUniqueId !== validation.componentUniqueId
			);

			newVState.push(validation);
			this.vState = newVState;
		},
		IsVStateValid() {
			const vStateWithErrors = this.vState.filter(
				s => !s.valid && s.messages.length > 0
			);

			return vStateWithErrors.length <= 0;
		},
		onValidate(validation, field) {
			this.frVState(validation);

			this.isFormValid = this.IsVStateValid();

			this.$emit('blurred', {
				isFormValid: this.isFormValid,
				field: field
			});
		} 
	}
};
</script>

<style lang="scss" scoped>
.field-container {
	margin-bottom: 10px;
	margin-left: $gutter-sm;

	&__label {
		font-weight: bold;
	}

	&__input {
		max-width: 160px;
		margin-top: 16px;
	}

	&__visible {
		visibility: visible;
		height: auto;
	}

	&__hidden {
		visibility: hidden;
		height: 0;
	}
}
</style>
